"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isString_1 = __importDefault(require("lodash/isString"));
var moment_1 = __importDefault(require("moment"));
var constant_1 = __importDefault(require("./constant"));
var JAPAN_TIME_OFFSET = constant_1.default.JAPAN_TIME_OFFSET;
/*
  Why not throw error?
  There might be the case when picking start and end date from a datepicker.
  The first render value is either undefined or null

  Validate type: Only allow moment instance & string type value.

  Dev notes: Currently if the string passed in is not a ISO string it could cause some issues rendering timezone correctly.
  For consistency sake, it is best to pass in ISOString whenever possible.
*/
// Converts dateTime string into japan moment instance.
function momentJpn(dateTime) {
    var isValidString = (0, isString_1.default)(dateTime) && dateTime !== '';
    var isValidDate = new Date(dateTime).toString() !== 'Invalid Date';
    if (!dateTime) {
        return null;
    }
    // Handle string
    if (isValidString && isValidDate) {
        return moment_1.default.utc(dateTime).utcOffset(JAPAN_TIME_OFFSET);
    }
    if (!moment_1.default.isMoment(dateTime)) {
        return null;
    }
    // Handle UTC moment instance (Ignore UTC parsing if moment is already in UTC format.)
    if (dateTime.isUTC()) {
        return dateTime.utcOffset(JAPAN_TIME_OFFSET);
    }
    // Handle non UTC moment instance
    return dateTime.utc().utcOffset(JAPAN_TIME_OFFSET);
}
exports.default = momentJpn;
